import { render } from "./CreateNewContactModal.vue?vue&type=template&id=0625f9dc&ts=true"
import script from "./CreateNewContactModal.vue?vue&type=script&lang=ts"
export * from "./CreateNewContactModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__